import * as DashboardConstants from '.././DashboardConstants';

export const trustIndexSummaryTableHeaders = [
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    {
        key: 'executions',
        header: DashboardConstants.TotalExecutions
    },
    {
        key: 'totalCompletions',
        header: DashboardConstants.TotalCompletions
    },
    {
        key: 'reruns',
        header: DashboardConstants.ReRuns
    },
    {
        key: 'schMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'terminations',
        header: DashboardConstants.Terminations
    },
    {
        key: 'successRate',
        header: DashboardConstants.SuccessRate
    }
];

export const successRateTableHeaders = [
    {
        key: 'geo',
        header: DashboardConstants.Geo
    },
    {
        key: 'executions',
        header: DashboardConstants.TotalExecutions
    },
    {
        key: 'completions',
        header: DashboardConstants.Completions
    },
    // {
    //     key: 'stopped',
    //     header: DashboardConstants.Stopped
    // },
    {
        key: 'reruns',
        header: DashboardConstants.ReRuns
    },
    {
        key: 'schMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'terminations',
        header: DashboardConstants.Terminations
    },
    {
        key: 'successRate',
        header: DashboardConstants.SuccessRatePercent
    },
    // {
    //     key: 'comments',
    //     header: DashboardConstants.Comments
    // }
];

export const successRateTableData = [
    {
        id: '1',
        geo: 'North america',
        executions: 20,
        completions: 50,
        stopped: 1,
        reruns: 10,
        schMisses: 0,
        terminations: 1097,
        successRate: '100%',
        comments: 'Rerun > failures'
    },
    {
        id: '2',
        geo: 'LATAM',
        executions: 20,
        completions: 50,
        stopped: 1,
        reruns: 10,
        schMisses: 0,
        terminations: 1097,
        successRate: '100%',
        comments: 'Rerun > failures'
    },
    {
        id: '3',
        geo: 'Global',
        executions: 20,
        completions: 50,
        stopped: 1,
        reruns: 10,
        schMisses: 0,
        terminations: 1097,
        successRate: '100%',
        comments: 'Rerun > failures'
    },
    {
        id: '4',
        geo: 'IBM Internal',
        executions: 20,
        completions: 50,
        stopped: 1,
        reruns: 10,
        schMisses: 0,
        terminations: 1097,
        successRate: '100%',
        comments: 'Rerun > failures'
    },
    {
        id: '5',
        geo: 'Europe',
        executions: 20,
        completions: 50,
        stopped: 1,
        reruns: 10,
        schMisses: 0,
        terminations: 1097,
        successRate: '100%',
        comments: 'Rerun > failures'
    },
    {
        id: '6',
        geo: 'AP',
        executions: 20,
        completions: 50,
        stopped: 1,
        reruns: 10,
        schMisses: 0,
        terminations: 1097,
        successRate: '100%',
        comments: 'Rerun > failures'
    }
];

export const botSummaryReportTableHeaders = [
    {
        key: 'botId',
        header: DashboardConstants.BotId
    },
    {
        key: 'leadPlatform',
        header: DashboardConstants.LeadPlatform
    },
    {
        key: 'subArea',
        header: DashboardConstants.SubArea
    },
    {
        key: 'processName',
        header: DashboardConstants.ProcessName
    },
    {
        key: 'geo',
        header: DashboardConstants.Geo
    },
    {
        key: 'processCritical',
        header: DashboardConstants.ProcessCritical
    },
    {
        key: 'requestedBy',
        header: DashboardConstants.RequestedBy
    },
    {
        key: 'deliveryModel',
        header: DashboardConstants.DeliveryModel
    },
    {
        key: 'supportStatus',
        header: DashboardConstants.SupportStatus
    },
    {
        key: 'completions',
        header: DashboardConstants.Completions
    },
    // {
    //     key: 'stopped',
    //     header: DashboardConstants.Stopped
    // },
    {
        key: 'schMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'terminations',
        header: DashboardConstants.Terminations
    },
    {
        key: 'reruns',
        header: DashboardConstants.ReRuns
    },
    {
        key: 'totalRuns',
        header: DashboardConstants.TotalRuns
    },
    {
        key: 'successRate',
        header: DashboardConstants.SuccessRatePercent
    },
    // {
    //     key: 'comments',
    //     header: DashboardConstants.Comments
    // },
];

export const botSummaryReportTableData = [
    {
        id: '1',
        botId: 1776,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU'
    },
    {
        id: '2',
        botId: 1777,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU'
    },
    {
        id: '3',
        botId: 1778,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU'
    },
    {
        id: '4',
        botId: 1779,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU'
    },
    {
        id: '5',
        botId: 1780,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU'
    },
    {
        id: '6',
        botId: 1781,
        leadPlatform: 'Market research',
        subArea: 'Scripting',
        processName: 'UBC_Scripting_SurveyLogic',
        geo: 'Global',
        processCritical: 'P1',
        requestedBy: 'Geo IT',
        deliveryModel: 'Model 1',
        supportStatus: 'BAU'
    }

];

export const automataStartedOnTimeTableHeaders = [
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    {
        key: 'scheduleMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'totalRuns',
        header: DashboardConstants.TotalRuns
    },
    {
        key: 'startedOnTime',
        header: DashboardConstants.StartedOnTime
    },
    {
        key: 'startedOnTimePercentage',
        header: DashboardConstants.StartedOnTimePercentage
    }
];

export const automataStartedOnTimeTableData = [
    {
        id: '1',
        priority: 'P1',
        scheduleMisses: 0,
        totalRuns: 200,
        startedOnTime: 200,
        startedOnTimePercentage: '100%'
    },
    {
        id: '2',
        priority: 'P2',
        scheduleMisses: 0,
        totalRuns: 200,
        startedOnTime: 200,
        startedOnTimePercentage: '100%'
    },
    {
        id: '3',
        priority: 'P3',
        scheduleMisses: 0,
        totalRuns: 200,
        startedOnTime: 200,
        startedOnTimePercentage: '100%'
    },
    {
        id: '4',
        priority: 'P4',
        scheduleMisses: 0,
        totalRuns: 200,
        startedOnTime: 200,
        startedOnTimePercentage: '100%'
    },
    {
        id: '5',
        priority: 'P5',
        scheduleMisses: 0,
        totalRuns: 200,
        startedOnTime: 200,
        startedOnTimePercentage: '100%'
    },
    {
        id: '6',
        priority: 'P6',
        scheduleMisses: 0,
        totalRuns: 200,
        startedOnTime: 200,
        startedOnTimePercentage: '100%'
    }
];

export const automataRunsOnTimeTableHeaders = [
    {
        key: 'priority',
        header: DashboardConstants.Priority
    },
    // {
    //     key: 'scheduleMisses',
    //     header: 'Sch. misses'
    // },
    {
        key: 'totalRuns',
        header: DashboardConstants.TotalRuns
    },
    {
        key: 'runOnTime',
        header: DashboardConstants.RunsOnTime
    },
    {
        key: 'runOnTimePercentage',
        header: DashboardConstants.RunOnTimePercentage
    }
];

export const automataRunsOnTimeTableData = [
    {
        id: '1',
        priority: 'P1',
        scheduleMisses: 0,
        totalRuns: 200,
        runsOnTime: 200,
        runOnTimePercentage: '100%'
    },
    {
        id: '2',
        priority: 'P2',
        scheduleMisses: 0,
        totalRuns: 200,
        runsOnTime: 200,
        runOnTimePercentage: '100%'
    },
    {
        id: '3',
        priority: 'P3',
        scheduleMisses: 0,
        totalRuns: 200,
        runsOnTime: 200,
        runOnTimePercentage: '100%'
    },
    {
        id: '4',
        priority: 'P4',
        scheduleMisses: 0,
        totalRuns: 200,
        runsOnTime: 200,
        runOnTimePercentage: '100%'
    },
    {
        id: '5',
        priority: 'P5',
        scheduleMisses: 0,
        totalRuns: 200,
        runsOnTime: 200,
        runOnTimePercentage: '100%'
    },
    {
        id: '6',
        priority: 'P6',
        scheduleMisses: 0,
        totalRuns: 200,
        runsOnTime: 200,
        runOnTimePercentage: '100%'
    }
];